// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__36bq1","title":"Header_title__2ujZt","side":"Header_side__3SShe"};